<template>
  <div class="main">
    <div class="header">
      <div class="back">
        <img src="@/assets/images/home/back-w.png" @click="back()"/>
      </div>
      <div class="info">
        <div>
          <img :src="zone && ($config.assetsHost + zone.scenarioimg)" ref="logo" @error="loadDefault"/>
        </div>
        <div>
          <span v-text="(zone&&zone.name)||'未设置'"></span>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="item" v-for="m in menus" :key="m.name" @click="toSetting(m)" v-if="!m.show">
        <img :src="m.icon"/>
        <span class="text" v-text="m.name"></span>
        <div class="float-right">
          <span v-if="m.total != undefined" class="num">{{m.total}}个</span>
          <img src="@/assets/images/home/xyy.png"/>
        </div>
      </div>
      <div class="item" @click="logout">
        <span class="text-center text" style="padding-left: 0">退出登录</span>
      </div>
    </div>
  </div>
</template>

<script>
import cache from '@/assets/lib/cache'
import { mapState } from 'vuex'
import basic from '@/model/zone'
import event from '@/model/event'
// import linkage from '@/model/linkage'

export default {
  name: 'User',
  data () {
    return {
      menus: [
        { name: '我的设备', icon: require('@/assets/images/user/mydevice.png'), router: '/user/device/list' },
        { name: '选择首页总控设备', icon: require('@/assets/images/user/wdsb.png'), router: '/user/device' },
        { name: '智能联动', icon: require('@/assets/images/user/linkage.png'), router: '/user/linkage', show: true, total: 0 },
        { name: '系统场景设置', icon: require('@/assets/images/user/xtsz.png'), router: '/user/scene' }
      ]
    }
  },
  computed: {
    ...mapState(['zone', 'extDevicesNdOrign', 'linkage', 'coreIds', 'devices'])
  },
  async created () {
    if (!this.zone) {
      await basic.getBasicInfo()
    }
  },
  watch: {
    extDevicesNdOrign (data) {
      // const whiteName = ['Super sensor', 'Human sensor', 'Light sensor']
      // let isTrue = data && data.some(item => whiteName.includes(item.devicetype.name))
      // this.menus[2].show = !isTrue
    },
    linkage () {
      this.menus[2].total = this.linkage.rule.filter(item => item.state).length
    },
    devices () {
      // 新版网关有智能联动功能
      if (this.devices[0] && this.devices[0]['version'] >= 45) {
        this.menus[2].show = false
      }
    }
  },
  methods: {
    logout () {
      // 登出的做法就是清除登录状态，然后刷新到登录页
      cache.removeSession('dtit_user')
      event.disconnect()
      window.location.reload(false)
    },
    loadDefault () {
      this.$refs.logo.src = require('@/assets/images/home/user-logo.png')
    },
    back () {
      this.$router.push('/')
    },
    toSetting (menu) {
      // Message.success('功能正在开发中...')
      this.$router.push(menu.router)
    }
  },
  mounted () {
    // 新版网关有智能联动功能
    if (this.devices[0] && this.devices[0]['version'] >= 45) {
      this.menus[2].show = false
    }
    this.menus[2].total = this.linkage.rule.filter(item => item.state).length
  }
}
</script>

<style scoped lang="less">
.main {
  display: flex;
  height: 100%;
  & .header {
    background-color: #35BD64;
    box-shadow: 0px 1px 6px 0px rgba(245, 246, 248, 0.08);
    padding: 7px 20px 35px 20px;
    & .back {
      & img {
        width: 30px;
      }
    }
    & .info {
      text-align: center;
      & img {
        border-radius: 5%;
        width: 73px;
      }
      & span {
        margin-top: 5px;
        display: inline-block;
        font-size: 17px;
        font-weight: 600;
        color: rgba(246, 247, 249, 1);
      }
    }
  }
  & .content {
    flex: 1;
    overflow-y: auto;
    padding: 20px;
    & .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      > img:first-child {
        width: 24px;
      }
      .text {
        flex: 1;
        font-size: 17px;
        font-weight: 600;
        color: rgba(34, 34, 34, 1);
        padding-left: 11px;
      }
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      padding: 16px 20px;
      & .float-right {
        .num {
          position: relative;
          top: -3px;
          right: 15px;
          color:rgba(137,137,137,1);
          font-size: 16px;
        }
        & img {
          width: 18px;
        }
      }
    }
  }
}
</style>
